import angular from 'angular';

import BackdropOverlayContent from './backdrop-overlay-content/bd-overlay-content.component';
import BackdropOverlayPreloader from './backdrop-overlay-preloader/bd-overlay-preloader.component';
import BackdropOverlayTitle from './backdrop-overlay-title/bd-overlay-title.component';
import BackdropToolbar from './backdrop-toolbar/bd-toolbar.component';

import './bd-overlay.styles.scss';

const BackdropOverlayTemplate = /* html */ `
  <div class="backdrop-overlay" ng-transclude></div>
`;

export const BackdropOverlayComponent = {
  selector: 'bdOverlay',
  transclude: true,
  template: BackdropOverlayTemplate,
};

export default angular.module('autoboard.backdropOverlay', [BackdropOverlayContent, BackdropOverlayTitle, BackdropOverlayPreloader, BackdropToolbar])
  .component(BackdropOverlayComponent.selector, BackdropOverlayComponent)
  .name;
